import { slice } from 'lodash';

import './team-list.style.sass';
import template from './team-list.tpl.pug';

class TeamListController {
    /* @ngInject */
    constructor($q) {
        this.$q = $q;
    }

    $onInit() {
        this.sortableOptions = {
            animation: 100,
            onStart: this.startSort.bind(this),
            onEnd: this.endSort.bind(this)
        };
    }

    $onChanges(changeObject) {
        if (changeObject.teams) {
            this.teams = slice(this.teams || []);
        }
    }

    isActive(team) {
        return this.selected && team && this.selected.id === team.id;
    }

    add() {
        return this.onAdd();
    }

    select(team) {
        return this.onSelect({
            team
        });
    }

    startSort() {
        this.sorting = true;
    }

    endSort() {
        return this.$q.when(this.onReorder({
            order: slice(this.teams)
        })).finally(() => {
            this.sorting = false;
        });
    }
}

export default {
    selector: 'dbATeamList',
    template: template(),
    controller: TeamListController,
    bindings: {
        teams: '<',
        selected: '<',
        onSelect: '&',
        onAdd: '&',
        onReorder: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-navigation/component/team-list/team-list.cmpt.js